/**
 * Small in-app airport dictionary. IATA + city name + country flag emoji.
 * Kept intentionally short — Simplifly accepts any valid IATA code, so this
 * is only for the autocomplete on the search form.
 */
export const AIRPORTS = [
  // UAE / GCC
  { code: "DXB", city: "Dubai", country: "United Arab Emirates", name: "Dubai International" },
  { code: "AUH", city: "Abu Dhabi", country: "United Arab Emirates", name: "Zayed International" },
  { code: "SHJ", city: "Sharjah", country: "United Arab Emirates", name: "Sharjah International" },
  { code: "DOH", city: "Doha", country: "Qatar", name: "Hamad International" },
  { code: "RUH", city: "Riyadh", country: "Saudi Arabia", name: "King Khalid International" },
  { code: "JED", city: "Jeddah", country: "Saudi Arabia", name: "King Abdulaziz International" },
  { code: "KWI", city: "Kuwait City", country: "Kuwait", name: "Kuwait International" },
  { code: "BAH", city: "Bahrain", country: "Bahrain", name: "Bahrain International" },
  { code: "MCT", city: "Muscat", country: "Oman", name: "Muscat International" },
  // China
  { code: "PEK", city: "Beijing", country: "China", name: "Beijing Capital International" },
  { code: "PKX", city: "Beijing", country: "China", name: "Beijing Daxing International" },
  { code: "PVG", city: "Shanghai", country: "China", name: "Shanghai Pudong International" },
  { code: "SHA", city: "Shanghai", country: "China", name: "Shanghai Hongqiao International" },
  { code: "CAN", city: "Guangzhou", country: "China", name: "Guangzhou Baiyun International" },
  { code: "SZX", city: "Shenzhen", country: "China", name: "Shenzhen Bao'an International" },
  { code: "CTU", city: "Chengdu", country: "China", name: "Chengdu Tianfu International" },
  { code: "TFU", city: "Chengdu", country: "China", name: "Chengdu Shuangliu International" },
  { code: "XIY", city: "Xi'an", country: "China", name: "Xi'an Xianyang International" },
  { code: "KMG", city: "Kunming", country: "China", name: "Kunming Changshui International" },
  { code: "HGH", city: "Hangzhou", country: "China", name: "Hangzhou Xiaoshan International" },
  { code: "URC", city: "Urumqi", country: "China", name: "Urumqi Diwopu International" },
  { code: "HKG", city: "Hong Kong", country: "Hong Kong SAR", name: "Hong Kong International" },
  { code: "MFM", city: "Macau", country: "Macau SAR", name: "Macau International" },
  { code: "TPE", city: "Taipei", country: "Taiwan", name: "Taoyuan International" },
  // Global connections
  { code: "LHR", city: "London", country: "United Kingdom", name: "Heathrow" },
  { code: "CDG", city: "Paris", country: "France", name: "Charles de Gaulle" },
  { code: "FRA", city: "Frankfurt", country: "Germany", name: "Frankfurt am Main" },
  { code: "IST", city: "Istanbul", country: "Türkiye", name: "Istanbul Airport" },
  { code: "SIN", city: "Singapore", country: "Singapore", name: "Changi" },
  { code: "BKK", city: "Bangkok", country: "Thailand", name: "Suvarnabhumi" },
  { code: "KUL", city: "Kuala Lumpur", country: "Malaysia", name: "KLIA" },
  { code: "ICN", city: "Seoul", country: "South Korea", name: "Incheon International" },
  { code: "NRT", city: "Tokyo", country: "Japan", name: "Narita International" },
  { code: "HND", city: "Tokyo", country: "Japan", name: "Haneda" },
  { code: "SYD", city: "Sydney", country: "Australia", name: "Kingsford Smith" },
  { code: "JFK", city: "New York", country: "United States", name: "John F. Kennedy International" },
  { code: "LAX", city: "Los Angeles", country: "United States", name: "Los Angeles International" },
];

export const findAirport = (code) =>
  AIRPORTS.find((a) => a.code === (code || "").toUpperCase());

export const searchAirports = (q) => {
  const query = (q || "").trim().toLowerCase();
  if (!query) return AIRPORTS.slice(0, 8);
  return AIRPORTS.filter((a) => {
    const hay = `${a.code} ${a.city} ${a.country} ${a.name}`.toLowerCase();
    return hay.includes(query);
  }).slice(0, 8);
};

export const CABIN_CLASSES = [
  { value: "economy", label: "Economy" },
  { value: "premiumEconomy", label: "Premium Economy" },
  { value: "business", label: "Business" },
  { value: "first", label: "First" },
];

export const cabinLabel = (v) =>
  CABIN_CLASSES.find((c) => c.value === v)?.label || v;
